import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '../../../components/common/atom/Button';
import { Text } from '../../../components/common/atom/Text';
import { Flex } from '../../../components/common/atom/Layout';
import {
  EditButton,
  OrderDetailLayout,
  OrderDetailLayoutWithChildren,
} from '../Detail/OrderDetailView';
import { DeliveryInfo } from '../Item/OrderInfoInput';

import { useContactInfo } from '../../../Hooks/useContactInfo';
import Loading from '../../../components/common/organism/Loading';

const ContactInfo = ({ contactInfo, orderId, shipmentRequired }) => {
  const {
    state,
    setValueAll,
    onChangeValue,
    onClickUpdateContactInfo,
    changeStatus,
    setChangeStatus,
    onClickCancelEdit,
  } = useContactInfo(contactInfo);
  const {
    name,
    mobile,
    address,
    detailAddress,
    isLoading,
    isEditLoading,
  } = state;

  const contactInfoList = shipmentRequired ? [
    ['받는 분', name],
    ['연락처', mobile],
    ['주소', `${address} ${detailAddress}`],
  ] : [
    ['받는 분', name],
    ['연락처', mobile],
  ];
  return (
    <>
      {isLoading ? (
        <Loading onlyLoader padding="5rem" />
      ) : changeStatus ? (
        <OrderDetailLayoutWithChildren title={shipmentRequired ? "배송정보" : "신청자정보"}>
          <DeliveryInfo
            onAddress={({ address, zipcode }) =>
              setValueAll({ object: { address, zipcode } })
            }
            onChange={onChangeValue}
            shipmentRequired={shipmentRequired}
            state={state}
          />
          <EditButton
            isEditLoading={isEditLoading}
            onChangeStatus={onClickCancelEdit}
            onSubmit={() => onClickUpdateContactInfo(orderId)}
          />
        </OrderDetailLayoutWithChildren>
      ) : (
        <Flex column alignItems="stretch" padding="0 0 1.25rem">
          <OrderDetailLayout title={shipmentRequired ? "배송정보" : "신청자정보"} infoList={contactInfoList} />{' '}
          <Button
            onClick={() => setChangeStatus(true)}
            color={changeStatus ? 'pinkishGrey' : 'orangePink'}
            style={{
              width: '50%',
              alignSelf: 'center',
            }}
          >
            <Text size="14">수정하기</Text>
          </Button>
        </Flex>
      )}
    </>
  );
};

export default React.memo(ContactInfo);

ContactInfo.propTypes = {
  contactInfo: PropTypes.object.isRequired,
  orderId: PropTypes.number.isRequired,
};
